<div>
	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Appointment'">
		<ui-text-form-field
			[title]="'Appointment name'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[placeholder]="'Select client...'"
			[isRequired]="true"
			[title]="'Client'"
			[valueAsSignal]="form.clientId"
			[items]="clientSelectionItems()"
			[isInDialog]="isInDialog()"
		></ui-select-item-field>

		<ui-date-time-form-field
			class="push-top-md"
			[title]="'Date & time'"
			[isRequired]="true"
			[valueAsSignal]="form.dateTime"
			[isInDialog]="isInDialog()"
		></ui-date-time-form-field>

		<ui-number-form-field
			class="push-top-md"
			[title]="'Length of appointment'"
			[subtitle]="'In minutes'"
			[isRequired]="true"
			[valueAsSignal]="form.length"
			[maxValue]="appointmentLength.maxValue"
			[minValue]="appointmentLength.minValue"
			[isInDialog]="isInDialog()"
		></ui-number-form-field>
	</lib-card>

	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Additional details'" class="push-top-md">
		<ui-text-form-field
			class="push-top-md"
			[title]="'Location'"
			[valueAsSignal]="form.location"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Meeting url'"
			[valueAsSignal]="form.meetingUrl"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Notes'"
			[valueAsSignal]="form.notes"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
			[enableEmoji]="false"
		></ui-text-area-form-field>
	</lib-card>

	<ui-form-save-button
		class="push-top-md"
		[isInDialog]="isInDialog()"
		[title]="isEditForm() ? 'Save' : 'Create'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</div>
